'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { HREF, URLSearch, UrlPath } from './shared';

export function useHref<T extends Partial<Record<string, string | string[]>>>() {
    const path = usePathname();
    const search = useSearchParams();

    const href = new HREF<T>(
        new UrlPath(path!),
        URLSearch.fromEntries(search !== null ? [...search.entries()] : []),
    );

    return href;
}
